import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';


interface EmployeeViewData {
  isElectronicStatementOnly?: boolean;
}

export const useGetEmployeeViewQuery = (employeeId?: string) => {
  const { data, isLoading, isSuccess } = useQuery(
    [employeeId],
    () => api.get(API_URL.EMPLOYEES_EMPLOYEE_VIEW_BY_EMPLOYEE_ID(employeeId || '')),
    {
      enabled: Boolean(employeeId),
    }
  );

  const employeeViewData = useMemo<EmployeeViewData>(
    () => ({
      isElectronicStatementOnly: data?.data?.is_electronic_statement_only,
    }),
    [data]
  );

  return {
    employeeViewData,
    isLoading,
    isSuccess,
  };
};
